export default __webpack_public_path__ + "static/media/mobile-app.c6ad3f33.png";